import { Meta } from './segments';
import { cookiePolicyMeta } from '@/utils';

const CookiePolicy = () => {
  return (
    <>
      <Meta {...cookiePolicyMeta} />

      <main className="container py-5">
        <h1 className="mb-2">Cookie Policy</h1>
        <p className="text-muted mb-4">Last updated: September 30, 2025</p>

        <section className="mb-4">
          <h2 className="mb-3">1. Introduction</h2>
          <p>
            This Cookie Policy explains how Convert Playlist ("we," "our," or
            "us") uses cookies and similar technologies on our website at{' '}
            <a
              href="https://convertplaylist.net"
              className="text-decoration-none"
            >
              convertplaylist.net
            </a>{' '}
            and our playlist conversion service (collectively, the "Service").
          </p>
          <p>
            By using our Service, you consent to the use of cookies and similar
            technologies in accordance with this Cookie Policy.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="mb-3">2. What Are Cookies?</h2>
          <p>
            Cookies are small text files that are stored on your device
            (computer, tablet, or mobile phone) when you visit a website. They
            are widely used to make websites work more efficiently, provide a
            better user experience, and give website owners information about
            how their website is being used.
          </p>
          <p>
            Cookies can be "persistent" or "session" cookies. Persistent cookies
            remain on your device when you go offline, while session cookies are
            deleted as soon as you close your web browser.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="mb-3">3. Types of Cookies We Use</h2>
          <p>We use the following types of cookies:</p>

          <h3 className="h5 mb-3">3.1 Essential Cookies</h3>
          <p>
            These cookies are necessary for the Service to function properly.
            They enable core functionality such as security, network management,
            and account authentication. You cannot opt out of these cookies.
          </p>

          <h3 className="h5 mb-3">3.2 Functional Cookies</h3>
          <p>
            These cookies enable us to provide enhanced functionality and
            personalization. They may be set by us or by third-party providers
            whose services we have added to our Service. If you disable these
            cookies, some or all of these services may not function properly.
          </p>

          <h3 className="h5 mb-3">3.3 Performance Cookies</h3>
          <p>
            These cookies allow us to count visits and traffic sources so we can
            measure and improve the performance of our Service. They help us
            know which pages are the most and least popular and see how visitors
            move around the Service. All information these cookies collect is
            aggregated and anonymous.
          </p>

          <h3 className="h5 mb-3">3.4 Targeting Cookies</h3>
          <p>
            These cookies may be set through our Service by our advertising
            partners. They may be used by those companies to build a profile of
            your interests and show you relevant advertisements on other
            websites. They do not directly store personal information but are
            based on uniquely identifying your browser and internet device.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="mb-3">4. Third-Party Cookies</h2>
          <p>
            In addition to our own cookies, we may also use various third-party
            cookies to report usage statistics of the Service and to deliver
            advertisements on and through the Service.
          </p>
          <p>
            <strong>Music Platform Integrations.</strong> When you sign in with
            or connect your accounts from music platforms (such as Spotify or
            YouTube), those platforms may set their own cookies or similar
            technologies during the OAuth login process. These cookies are
            controlled by the respective platforms and are subject to their own
            privacy and cookie policies.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="mb-3">5. How to Manage Cookies</h2>
          <p>
            Most web browsers allow you to control cookies through their
            settings preferences. However, if you limit the ability of websites
            to set cookies, you may worsen your overall user experience, since
            it will no longer be personalized to you. It may also stop you from
            saving customized settings like login information.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="mb-3">6. Browser-Specific Instructions</h2>
          <p>
            Here are instructions for managing cookies in some popular browsers:
          </p>
          <ul>
            <li className="mb-2">
              <strong>Google Chrome:</strong> Settings → Privacy and security →
              Cookies and other site data
            </li>
            <li className="mb-2">
              <strong>Mozilla Firefox:</strong> Options → Privacy & Security →
              Cookies and Site Data
            </li>
            <li className="mb-2">
              <strong>Safari:</strong> Preferences → Privacy → Cookies and
              website data
            </li>
            <li className="mb-2">
              <strong>Microsoft Edge:</strong> Settings → Cookies and site
              permissions → Cookies and site data
            </li>
          </ul>
        </section>

        <section className="mb-4">
          <h2 className="mb-3">7. Changes to This Cookie Policy</h2>
          <p>
            We may update this Cookie Policy from time to time. The most current
            version will always be posted on our website. If we make material
            changes to this Cookie Policy, we will notify you by email or by
            posting a notice on our website.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="mb-3">8. Contact Us</h2>
          <p>
            If you have any questions about this Cookie Policy, please contact
            us at{' '}
            <a
              href="mailto:contact@convertplaylist.net"
              className="text-decoration-none"
            >
              contact@convertplaylist.net
            </a>
            .
          </p>
        </section>
      </main>
    </>
  );
};

export default CookiePolicy;
